import {
  Button,
  colours,
  type ButtonProps,
} from "@validereinc/common-components";
import classNames from "classnames/bind";
import React, { forwardRef } from "react";
import styles from "./AssistantButton.module.css";

export type AssistantButtonProps = {
  isReady?: boolean;
  isSeen?: boolean;
  isActive?: boolean;
} & ButtonProps;

const cx = classNames.bind(styles);

export const AssistantButton = forwardRef<
  HTMLButtonElement,
  AssistantButtonProps
>(
  (
    {
      isReady = false,
      isSeen = false,
      isActive = false,
      isLoading = false,
      disabled = false,
      ...restProps
    },
    ref
  ) => {
    return (
      <Button
        {...restProps}
        ref={ref}
        variant="special"
        icon="sparkle"
        iconProps={{
          size: 18,
          colour:
            (isReady && !isSeen) || isActive
              ? "white"
              : colours.colours.teal[800],
          weight: "fill",
        }}
        size="xx-small"
        disabled={disabled}
        isLoading={isLoading}
        className={cx({
          "button--ready": isReady && !isSeen,
          "button--active": isActive,
          "button--ready-and-seen": isReady && isSeen,
        })}
      />
    );
  }
);

AssistantButton.displayName = "AssistantButton";
